<template>
  <div>
    <Main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :isVc="isVc"
      @reload="getData"
      @openReply="openReply"
    >
      <div slot="toolbar" class="table_toolbar">
        <div class="d-flex">
          <SearchTabs
            ref="searchTabs"
            :amzReplenishmentCode="amzReplenishmentCode"
            @change="getData"
          />
        </div>
        <div class="toolbar_tools">
          <vxe-button circle>
            <i class="vxe-icon--search" @click="advquery()" />
          </vxe-button>
        </div>
      </div>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>

    <SearchForm
      ref="header"
      :visible.sync="advqueryVisible"
      :isVc="isVc"
      @query="getData"
    />

    <SkuDetail
      :visible.sync="skuDetailOpts.visible"
      :amzReplenishmentDetailCode="skuDetailOpts.amzReplenishmentDetailCode"
    />
  </div>
</template>
<script>
import Main from './main'
import SearchTabs from './search-tabs'
import SearchForm from './search-form'
import SkuDetail from '../sku-detail'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main, SearchTabs, SearchForm, SkuDetail },
  props: {
    amzReplenishmentCode: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      advqueryVisible: false,
      skuDetailOpts: { visible: false, amzReplenishmentDetailCode: '' },
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentCode) return

      const form = this.$refs.header.form
      const restockStatus = this.$refs.searchTabs.restockStatus
      const params = {
        ...form,
        ...this.page,
        amzReplenishmentCode: this.amzReplenishmentCode,
        listApprovalStatus: ['C'],
        listRestockStatus: [restockStatus].filter(Boolean),
      }
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListApi(params)
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    advquery() {
      this.advqueryVisible = true
    },
    openReply({ amzReplenishmentDetailCode }) {
      this.skuDetailOpts = { visible: true, amzReplenishmentDetailCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.table_toolbar {
  display: flex;
  justify-content: space-between;
  .toolbar_tools {
    display: flex;
    align-items: center;
    margin-right: 12px;
    .vxe-button--content {
      i {
        font-size: 13px;
      }
    }
  }
}
</style>
